import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=e7ec76f6&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style0 from "./Email.vue?vue&type=style&index=0&id=e7ec76f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ec76f6",
  null
  
)

export default component.exports